import useOneRepMaxChartLines from "../useOneRepMaxChartLines";

function useOneRepMaxChartColor() {
  return useOneRepMaxChartLines().getLineColor;
}

export default useOneRepMaxChartColor;
